import { Delete, EditGlyph, OverflowMenu } from '@wfp/icons-react';
import { Text } from '@wfp/react';
import React, { useRef } from 'react';
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from 'react-simple-dropdown';

const ReviewIcon = ({
  permissions,
  closed,
  user,
  activeUser,
  data,
  toggleDeleteConfirmationModal,
  toggleEdit,
  isReportPublished,
  nested = false,
  parentClosed = false,
  isCommentsUpdating,
}) => {
  const dpRef = useRef(null);

  function checkIssueAnotherUserReplies() {
    const { comments } = data || {};
    let hasAnotherUserReplies = false;

    if (comments)
      comments.forEach(item => {
        if (item.user.username !== activeUser) hasAnotherUserReplies = true;
      });

    return hasAnotherUserReplies;
  }

  const {
    delete_issue,
    delete_own_issue,
    change_issue,
    change_own_issue,
    change_comment,
    change_own_comment,
    delete_own_comment,
  } = permissions;

  let displayEditIcon, displayDeleteIcon;
  if (!nested) {
    displayEditIcon =
      !closed &&
      ((!!change_own_issue && user.username === activeUser) || !!change_issue);
    displayDeleteIcon =
      !closed &&
      ((!!delete_own_issue && user.username === activeUser) ||
        !!delete_issue) &&
      (!checkIssueAnotherUserReplies() || !!delete_issue);
  } else {
    displayEditIcon =
      !parentClosed &&
      ((!!change_own_comment && user.username === activeUser) ||
        !!change_comment);
    displayDeleteIcon =
      !parentClosed && !!delete_own_comment && user.username === activeUser;
  }

  const editIcon = displayEditIcon && (
    <EditGlyph color="#71767E" className="noselect" />
  );
  const deleteIcon = displayDeleteIcon && (
    <Delete fill="#71767E" id={data.pk} className="noselect" />
  );

  if (!displayDeleteIcon && !displayEditIcon) return null;

  return (
    <Dropdown ref={dpRef}>
      <DropdownTrigger>
        <OverflowMenu
          width="20"
          height="20"
          className="acr-comment-dropdown-menu"
          color="#595F65"
        />
      </DropdownTrigger>
      <DropdownContent>
        <div>
          {displayEditIcon && !closed && (
            <div
              onClick={() => {
                if (!isCommentsUpdating) {
                  dpRef.current.hide();
                  toggleEdit();
                }
              }}
              className="acr-comments-action"
            >
              <span>{editIcon}</span>
              <Text>Edit</Text>
            </div>
          )}
          {displayDeleteIcon && !isReportPublished && (
            <div
              onClick={toggleDeleteConfirmationModal}
              className="acr-comments-action"
            >
              <span>{deleteIcon}</span>
              <Text>Delete</Text>
            </div>
          )}
        </div>
      </DropdownContent>
    </Dropdown>
  );
};

export default ReviewIcon;
